import { useState, useEffect } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";

const MainTest = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const ref = collection(db, "test");
        const dataArr = [];
        const snapshot = await getDocs(ref);
        snapshot.forEach((doc) =>
          dataArr.push({ id: doc.id, data: doc.data() })
        );
        setData(dataArr);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  console.log(data);
  return (
    <div>
      <h1>MainTest</h1>
    </div>
  );
};

export default MainTest;
